import { validLocales } from '$lib/i18n';

// matches all routes that don't start with a valid locale
//   /foo/bar should match and redirect to /de/foo/bar
//   /de/foo/bar should not match and return a 404
export const match = (url: string) => !validLocales.includes(url.split('/')[0]);
